// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1cZ8w";
var _4 = "ul-50KDP";
var _5 = "icon-1Ird9";
var _6 = "button-2aQ_r";
var _7 = "page-3ECZe";
var _8 = "selected-28apb";
var _9 = "ellipsis-2fpYe";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "ul", _5 as "icon", _6 as "button", _7 as "page", _8 as "selected", _9 as "ellipsis" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "ul": _4, "icon": _5, "button": _6, "page": _7, "selected": _8, "ellipsis": _9 }
